import { useNavigate } from "react-router-dom";

import { ColocaResourceLink } from "@/shared/components/data-display/ColocaResourceLink";
import useTranslations from "@/shared/lang/useTranslations";

import { PocketIcon } from "./PocketIcon";

type PocketCardLinkProps = {
  pocketId: string;
  name: string;
  color?: string | null;
  icon?: string | null;
};

export const PocketCardLink = ({ pocketId, name, color, icon }: PocketCardLinkProps) => {
  const { t } = useTranslations("cards");
  const navigate = useNavigate();

  return (
    <ColocaResourceLink
      visual={<PocketIcon icon={icon} color={color} size={40} rounded="md" />}
      label={t("card_detail_pocket_link_label")}
      title={name}
      onClick={() => navigate(`/app/cards/pockets/${pocketId}`)}
    />
  );
};
